<template>
  <section>
    <div
      v-if="title"
      class="flex items-center justify-between px-4 z-10 sm:px-0"
    >
      <label
        class="block uppercase text-xs text-gray-500 font-medium py-2 dark:text-gray-300"
      >
        {{ title }}
      </label>
      <slot name="right"></slot>
    </div>
    <div
      class="bg-white relative overflow-hidden sm:rounded-md dark:bg-gray-900 dark:shadow dark:text-gray-300 dark:border-1 dark:border-gray-700"
      :class="{ 'sm:border': !noBorder }"
    >
      <slot></slot>
    </div>
    <p
      v-if="desc"
      class="text-xs mt-1 text-gray-500 px-4 sm:px-0 dark:bg-gray-850"
    >
      {{ desc }}
    </p>
    <Error
      class="text-danger-600 text-xs px-4 pe-6 py-2 bg-danger-50 border-b border-t border-danger-200 sm:border sm:rounded-md sm:mt-1"
      :errors="sectionErrors"
    />
  </section>
</template>

<script>
export default {
  props: {
    title: { type: String, default: null },
    desc: { type: String, default: null },
    type: { type: String },
    noBorder: Boolean,
    errors: { type: Array, default: () => [] },
  },

  computed: {
    sectionErrors() {
      return this.errors?.filter((err) => err.type.startsWith(this.type));
    },
  },
};
</script>
